import humps from 'lodash-humps-ts';

import { snakes } from '@utils/lodash';
import { authAxios } from '@components/Auth';
import { Billing, BillingList } from '@models/Billing';
import { API_V1_BASE } from '@config';
import { paginate, Pagination, PaginationParams } from '@models/Pagination';
import { WithParams } from '@utils/typescript';

export type GetAllBillingParams = PaginationParams;

export type GetBillingParams = {
  id: number;
};

export type CreateBillingParams = WithParams<{
  order_number: string;
}>;

export class BillingApi {
  static getAll = async (params = {} as GetAllBillingParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/billings`, { params: snakes(params) })
      .then((response) => paginate(response) as [BillingList[], Pagination]);
  };

  static get = async ({ id }: GetBillingParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/billings/${id}`)
      .then((response) => humps(response.data) as Billing);
  };

  static create = async (params: CreateBillingParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/user/billings`, snakes(params))
      .then((response) => humps(response.data) as Billing);
  };
}
